import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'

import reducerCreator, { statusReducer } from 'utils/reducerCreator'
import persistentReducerCreator from 'utils/persistentReducerCreator'

import gaProfiles from 'reducers/gaProfiles'
import integrations from 'reducers/integrations'
import subscriptionStatus from 'reducers/subscriptionStatus'

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore)

const rootReducer = combineReducers({
  gaProfiles,
  integrations,
  subscriptionStatus,
  account: reducerCreator('GET_ACCOUNT', {}),
  changes: statusReducer('GET_GIT_CHANGES', []),
  chartDate: persistentReducerCreator('SET_DATE_FILTER', 'last30Days'),
  contributions: reducerCreator('GET_GIT_CONTRIBUTIONS', []),
  events: reducerCreator('GET_GA_EVENTS', []),
  mrr: statusReducer('GET_STRIPE_MRR', []),
  pages: reducerCreator('GET_GA_PAGES', []),
  sources: reducerCreator('GET_GA_SOURCES', []),
  tasks: statusReducer('GET_JIRA_TASKS', []),
  users: statusReducer('GET_GA_USERS', [])
})

export default createStoreWithMiddleware(rootReducer)